import { states } from './lib/states';
import {
  validateCardNumber as creditcard,
  validateCvc as cvc,
  validateExpiration as expiration,
} from 'modules/credit-card/validations';

const REGEXP = {
  email: /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i,
  validCharacters: /^[^!@$%^&*()_+~"\]\[\{\}:;\/0-9]+$/,
  digit: /\d/,
  letter: /[a-zA-Z]/,
  passwordComplexity: /^(?=.*\d)(?=.*(_|-|'|\/|\[|\]|\{|\}|\||[@!?#$%^&*)(+=.`,:;<>~]))(?=.*[a-zA-Z]).+/,
  specialCharacter: /_|-|'|\/|\[|\]|\{|\}|\||[@!?#$%^&*)(+=.`,:;<>~]/,
  address: /^[^!@$%^&*()_+~"\]\[\{\}:;\/]+$/,
};

export function regexp(val, regex) {
  return !!val.match(regex);
}

export function digit(val) {
  return regexp(val, REGEXP.digit);
}

export function email(val) {
  return regexp(val, REGEXP.email);
}

export function letter(val) {
  return regexp(val, REGEXP.letter);
}

export function matches(val1, val2) {
  return val1 === val2;
}

export function minLength(val, min) {
  return val.length >= min;
}

export function name(val) {
  return regexp(val, REGEXP.validCharacters);
}

export function password(val) {
  return regexp(val, REGEXP.passwordComplexity);
}

export function postalCode(val) {
  return val.length === 5 || val.length === 9;
}

export function required(val) {
  if (val === undefined || val === null) {
    return false;
  }
  if (typeof val === 'number') return true;
  return !!val;
}

export function specialCharacter(val) {
  return regexp(val, REGEXP.specialCharacter);
}

export function address(val) {
  return regexp(val, REGEXP.address);
}

export function state(val) {
  return !!states[val];
}

export function templateDate(val) {
  const [mm, dd, yyyy] = val.split(/\s*\/\s*/).map(f => parseInt(f, 10));
  return (
    (mm <= 12 && mm >= 1) &&
    (dd <= 31 && dd >= 1) &&
    (yyyy <= 2099 && yyyy >= 1900)
  );
}

export default {
  creditcard,
  cvc,
  digit,
  email,
  expiration,
  letter,
  matches,
  minLength,
  name,
  password,
  postalCode,
  regexp,
  required,
  specialCharacter,
  address,
  state,
  templateDate,
};



/** WEBPACK FOOTER **
 ** ./modules/validations/index.js
 **/